import queryClient from "api/queryClient.ts";
import { getOfferQueryOptions } from "api/TenantSlug/Offer/queryOptions.ts";
import { PerformanceReport } from "components/Report/PerformanceReport/PerformanceReport";
import { TenantPage } from "components/UI/TenantPage/TenantPage";
import { PermissionEnum } from "types/enums.ts";
import { createTenantFileRoute } from "utils/createTenantFileRoute";
import { getReportHeaderItems } from "utils/tenantHeaderItems";

export const Route = createTenantFileRoute(
    "/_authenticated/$tenantSlug/_layout/report/_layout/offer/_layout/$offerId/"
)({
    component: AffiliateReportPage,
    staticData: {
        permissions: [PermissionEnum.ReportOffer],
        showInSideMenu: false,
        label: "pages.report.offer.detail",
    },
    loader: async ({ params }: { params: { offerId: string } }) => {
        let breadcrumb = params.offerId;

        try {
            const { offer } = await queryClient.ensureQueryData(getOfferQueryOptions(params.offerId, {}));

            breadcrumb = offer?.visible_title || breadcrumb;
        } catch (e) {
            console.error(e);
        }

        return {
            breadcrumb,
        };
    },
});

function AffiliateReportPage() {
    const { offerId } = Route.useParams();
    return (
        <TenantPage headerNavigationItems={getReportHeaderItems}>
            <PerformanceReport offerId={offerId} />
        </TenantPage>
    );
}
